(() => {
  const PRICE_TARGETS = [
    { badge: '[id^="price-template--"] .price__badge-sale', price: '.price-item--sale' },
    {
      badge: '.cart-drawer .cart-item__price-wrapper .price__badge-sale',
      price: ':scope > .price:not(.cart-item__old-price)',
    },
  ];

  function getDiscount() {
    const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!match) return null;

    const code = decodeURIComponent(match[1]).split(',')[0].trim();
    const percent = code.match(/(\d{2})$/);
    if (!percent) return null;

    return { code, percent: parseInt(percent[1], 10) };
  }

  // Rewrites the number inside a formatted price (e.g. "€1.239,00", "£199.00") keeping its currency and separators.
  function discountFormattedPrice(text, percent) {
    const match = text.match(/\d[\d.,\s\u00a0]*\d/);
    if (!match) return null;

    const number = match[0];
    const decimalMatch = number.match(/[.,](\d{2})$/);
    const decimalSeparator = decimalMatch ? number.charAt(number.length - 3) : '';
    const integerPart = decimalMatch ? number.slice(0, -3) : number;
    const thousandsSeparator = (integerPart.match(/[^\d]/) || [''])[0];

    const cents = parseInt(integerPart.replace(/[^\d]/g, '') + (decimalMatch ? decimalMatch[1] : '00'), 10);
    const discounted = Math.round((cents * (100 - percent)) / 100);

    const whole = Math.floor(discounted / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    const formatted = decimalMatch ? `${whole}${decimalSeparator}${String(discounted % 100).padStart(2, '0')}` : whole;

    return text.replace(number, formatted);
  }

  function applyDiscount() {
    const discount = getDiscount();
    if (!discount) return;

    PRICE_TARGETS.forEach((target) => {
      document.querySelectorAll(target.badge).forEach((saleBadge) => {
        const next = saleBadge.nextElementSibling;
        if (!next || !next.classList.contains('price__badge-code')) {
          const badge = document.createElement('span');
          badge.className = 'badge price__badge-code';
          badge.textContent = `${discount.code} - ${discount.percent}% OFF`;
          saleBadge.insertAdjacentElement('afterend', badge);
        }

        const priceEl = saleBadge.parentElement.querySelector(target.price);
        if (!priceEl || priceEl.dataset.codeDiscounted) return;

        const discountedText = discountFormattedPrice(priceEl.textContent, discount.percent);
        if (!discountedText) return;

        priceEl.dataset.codeDiscounted = 'true';
        priceEl.textContent = discountedText.trim();
      });
    });
  }

  applyDiscount();
  new MutationObserver(applyDiscount).observe(document.body, { childList: true, subtree: true });
})();
